import { msg, str } from "@lit/localize";
import type { ElementInternals } from "element-internals-polyfill/dist/element-internals";
import { html, LitElement } from "lit";
import { customElement, queryAssignedNodes } from 'lit/decorators.js';

/**
 * Tag holder for left menu.
 *
 * @slot - Left menu content
 */
@customElement('menu-left')
export class MenuLeft extends LitElement {
    static override styles = [];

    private _internals: ElementInternals;

    @queryAssignedNodes({flatten: true})
    contents!: Node[];

    constructor() {
        super();
        this._internals = this.attachInternals();
        this._internals.role = 'navigation';
    }

    override connectedCallback(): void {
        super.connectedCallback();
        this.addEventListener('focus', this._delegateFocus);
    }

    override disconnectedCallback(): void {
        super.disconnectedCallback();
        this.removeEventListener('focus', this._delegateFocus);
    }

    override render() {
        this._internals.ariaLabel = msg(str`Menu boczne`);
        return html`
            <slot></slot>
        `;
    }

    override focus(): void {
        this._delegateFocus();
    }

    private _delegateFocus() {
        console.log('_delegate');
        for (const node of this.contents) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const link = (node as HTMLElement).querySelector('a[href]');
            if (link) {
                (link as HTMLAnchorElement).focus();
                break;
            }
          }
        }
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "menu-left": MenuLeft,
    }
}
